module.exports = __webpack_public_path__ + "static/media/promofour.f4927361.png";